module.exports = __webpack_public_path__ + "img/nmmj.4f4092c4.png";